module.exports = __webpack_public_path__ + "static/img/image_people@2x.84dd7cd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/approve/image_people@2x.png
// module id = aXOz
// module chunks = 0